/* tslint:disable */
/* eslint-disable */
/**
 * RX360-WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubscriptionStatusEnum = {
    Active: 'Active',
    Expired: 'Expired',
    Cancelled: 'Cancelled',
    Refunded: 'Refunded',
    Consumed: 'Consumed',
    Stopped: 'Stopped',
    NoSubscription: 'No Subscription'
} as const;
export type SubscriptionStatusEnum = typeof SubscriptionStatusEnum[keyof typeof SubscriptionStatusEnum];


export function instanceOfSubscriptionStatusEnum(value: any): boolean {
    return Object.values(SubscriptionStatusEnum).includes(value);
}

export function SubscriptionStatusEnumFromJSON(json: any): SubscriptionStatusEnum {
    return SubscriptionStatusEnumFromJSONTyped(json, false);
}

export function SubscriptionStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatusEnum {
    return json as SubscriptionStatusEnum;
}

export function SubscriptionStatusEnumToJSON(value?: SubscriptionStatusEnum | null): any {
    return value as any;
}

